// DonutChart.js
import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register components with ChartJS
ChartJS.register(ArcElement, Tooltip, Legend);

const DonutChart = ({ values, colors }) => {
  // Ensure values sum up to 100
  const total = values.reduce((acc, val) => acc + val, 0);
  const validValues = values.map(val => (val / total) * 100);
  

  // Chart data
  const data = {
    labels: ["Water", "Rent", "Garbage", "Service"],
    datasets: [
      {
        label: "Progress",
        data: validValues,
        backgroundColor: colors,
        hoverBackgroundColor: colors,
        borderWidth: 0,
      },
    ],
  };
   // Custom text display in the center
   const plugins = [
    {
      id: "textDisplay",
      beforeDraw: (chart) => {
        const { width, height, ctx } = chart;
        ctx.restore();
        const fontSize = (height / 114).toFixed(2);
        ctx.font = `${fontSize}em sans-serif`;
        ctx.textBaseline = "middle";

        const text = `Invoices`; // Display the percentage prop value
        const textX = Math.round((width - ctx.measureText(text).width) / 2);
        const textY = height / 2;

        ctx.fillText(text, textX, textY);
        ctx.save();
      },
    },
  ];



  // Chart options
  const options = {
    cutout: "65%", // Adjust the size of the donut hole
    plugins: {
      legend: {
        display: false,
        position: "bottom",
      },
      
    },
    onHover: (event, chartElement) => {
      event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
    },
  };

  return <Doughnut data={data} options={options} plugins={plugins} />;
};

export default DonutChart;
